import React, { useContext } from 'react';
import { TextInput, View } from 'react-native';
import { Box } from '../Box';
import { useCountStepper } from './hooks';
import { useStepperStyle } from './style';
export * from './hooks';
const StepperContext = React.createContext({
    value: 0,
    disable: false,
    isDecreaseDisabled: false,
    isIncreaseDisabled: false,
    increase: () => { },
    decrease: () => { },
    handleChange: (val) => { },
    handleBlur: () => { },
});
export function useStepperContext() {
    return useContext(StepperContext);
}
export function BaseStepper(props) {
    const { disable, children } = props || {};
    const { editingValue, isDecreaseDisabled, isIncreaseDisabled, handleBlur, handleChange, increase, decrease, } = useCountStepper(props);
    return (React.createElement(StepperContext.Provider, { value: {
            value: editingValue,
            isDecreaseDisabled,
            isIncreaseDisabled,
            disable,
            handleChange,
            handleBlur,
            increase,
            decrease,
        } }, children));
}
export function Stepper(props) {
    const { style } = props || {};
    const { style: Styles } = useStepperStyle();
    return (React.createElement(BaseStepper, Object.assign({}, props),
        React.createElement(View, { style: [Styles.value, style] },
            React.createElement(Stepper.Decrease, null),
            React.createElement(Stepper.Content, null),
            React.createElement(Stepper.Increase, null))));
}
Stepper.Content = () => {
    const { style: Styles } = useStepperStyle();
    const { disable, value, handleChange, handleBlur } = useContext(StepperContext);
    return (React.createElement(TextInput, { editable: !disable, style: Styles.input, keyboardType: "numeric", value: `${value}`, maxLength: 10, onBlur: handleBlur, onChangeText: (text) => handleChange(+text) }));
};
Stepper.Decrease = () => {
    const { style: Styles } = useStepperStyle();
    const { isDecreaseDisabled, decrease } = useContext(StepperContext);
    return (React.createElement(Box, { onPress: decrease, style: [
            Styles.box,
            Styles.left,
            isDecreaseDisabled ? Styles.disabled : {},
        ] }, "-"));
};
Stepper.Increase = () => {
    const { style: Styles } = useStepperStyle();
    const { isIncreaseDisabled, increase } = useContext(StepperContext);
    return (React.createElement(Box, { onPress: increase, style: [
            Styles.box,
            Styles.right,
            isIncreaseDisabled ? Styles.disabled : {},
        ] }, "+"));
};
export default Stepper;
